export default __webpack_public_path__ + "static/media/logo_minified.782d69a3.svg";